angular.module('controllers').controller('clientBlacklistController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$timeout', '$route', '$routeParams', '$location', '$window',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $timeout, $route, $routeParams, $location, $window) {
		$rootScope.path = '/client-blacklist';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'client-blacklist';
		$scope.pathTemplate = 'clients/clientsblacklist';
		$scope.title = 'Clienti blacklist';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'client_blacklist_phone';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
    $scope.additionals['pathOrder'] = '/order';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'client_blacklist_phone':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
			'client_name':{'label': 'Nume client', 'filter': 1, 'filterType': 'input'},
			'client_blacklist_reason':{'label': 'Motiv', 'filter': 1, 'filterType': 'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};
		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
    $scope.additionals['columnDisplay'] = 'client_blacklist_phone';
		$scope.additionals['jsonPath'] = '/json';


		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId, model, key) {
			if (!angular.isUndefined(key)) {
				model[key][paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[key][paramId] = '';
				}
			} else {
				model[paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[paramId] = '';
				}
			}
		}

		$scope.additionals['clients'] = [];
		$scope.additionals['getClients'] = function (search) {
			if (!angular.isUndefined(search)) {
				if (search != '' && search != 'undefined' && search.length >= 2) {
					var pathClient = 'search=' + search;
				}
			}

			$scope.additionals['errors'] = {};
			if (!angular.isUndefined($scope.errors)) {
				$scope.errors['client_id'] = {};
			}
			if (!angular.isUndefined(pathClient) && pathClient != 'undefined') {
				return Crud.get($scope.path + '/getClients?' + pathClient)
					.then(function (data) {
						$scope.additionals['clients'] = data.data.clients;
						return data.data.clients;
					});
			} else {
				return [];
			}

		}





        $scope.additionals['searchTermSearch'];
        $scope.additionals['clearSearchTermSearch'] = function() {
            $scope.additionals['searchTermSearch'] = '';
        };
        $scope.additionals['onSearchChangeSearch'] = function(ev) {
            ev.stopPropagation();
        };



		$scope.additionals['function']= function(ev, model) {


			if($scope.action == 'update') {

			}
			if ($scope.action != 'updatemultiple') {




			}
		}

		$scope.additionals['internFunction']= function(ev, model) {
			/*$scope.$watch('modelData', function (item) {
				console.log('here')
				//item.address = $scope.modelData;
				console.log($scope.modelData)

				model = $scope.modelData;
			}, true);*/

			if($scope.action == 'updatemultiple') {

			} else {
				angular.forEach(model.address, function (item, indexAddress) {


				});

			}
		}

		$scope.additionals['functionResult']= function(ev, data) {

			if (!angular.isUndefined($scope.modelData.client_first_name)) {
				$scope.modelData.client_first_name = $scope.additionals['formatTextResult']($scope.modelData.client_first_name);
			}
			if (!angular.isUndefined($scope.modelData.client_last_name)) {
				$scope.modelData.client_last_name = $scope.additionals['formatTextResult']($scope.modelData.client_last_name);
			}

			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].client_first_name)) {
						$scope.modelsData[key].client_first_name = $scope.additionals['formatTextResult']($scope.modelsData[key].client_first_name);
						$scope.modelsData[key].client_last_name = $scope.additionals['formatTextResult']($scope.modelsData[key].client_last_name);

					}
				});
			}
		}

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

	}]
);
